import AppLayout from "../components/layout/AppLayout";
import MemberTableComponent from "../components/member/MemberTableComponent";

export default function Member() {
  return (
    <AppLayout>
      <MemberTableComponent />
    </AppLayout>
  );
}
